import React, { useEffect, useState } from "react";

import { getCurrentUser } from "@util/api";
import { isBrowser } from "@util/isBrowser";
import { pushDataLayerEvent } from "@util/tracking";

interface IUserCompany {
    id: number;
    name: string;
    short_name: string;
}
interface IUserProps {
    logged_in: boolean;
    company?: IUserCompany;
    cropped_name?: string;
    email?: string;
    favorite_posts?: number[];
    name?: string;
    id?: number;
}

interface IUserProviderProps {
    user?: IUserProps;
}

const defaultUserState = { logged_in: false };

const User = React.createContext<IUserProps>(defaultUserState);

const UserProvider: React.FC<IUserProviderProps> = props => {
    const initialState = props.user || defaultUserState;
    const [user, setUser] = useState(initialState);
    if (isBrowser) {
        useEffect(() => {
            let userData: IUserProps = defaultUserState;
            getCurrentUser()
                .then(res => {
                    userData = res.data;
                    setUser(res.data);
                })
                .catch(e => {
                    console.error("Unable to fetch current user");
                    console.error(e);
                })
                .then(() => {
                    const isMuser = userData.email && userData.email.split("@")[1] === "themuse.com";
                    pushDataLayerEvent("userDataFetched", {
                        is_signed_in: userData.logged_in || false,
                        is_muser: isMuser || false,
                        is_admin: isMuser || false,
                        user_id: userData.id || null
                    });
                });
        }, []);
    }
    return <User.Provider value={user}>{props.children}</User.Provider>;
};

export { IUserProps, User, UserProvider };
